import { Column, Icon, Row, Text } from "@amzn/meridian";
import React from "react";
import { COLORS } from "src/constants/colors";
import { useNavigate } from "react-router-dom";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import CompletedInspectionCard from "./completedInspectionCard";
import { useAppSelector } from "src/store/store";

const CompletedInspections = () => {
  const { completedInspections } = useAppSelector((state) => state.data);
  const navigate = useNavigate();
  return (
    <Column
      className="questions-page"
      minHeight="100vh"
      alignmentVertical="justify"
      backgroundColor={COLORS.DARKER_WHITE}
    >
      <Column>
        <Column
          width="100%"
          backgroundColor={COLORS.WHITE}
          spacingInset="600 500 400"
        >
          <Row>
            <div
              style={{ cursor: "pointer", marginLeft: "50px" }}
              onClick={() => navigate("/")}
            >
              <Icon tokens={chevronLeftLargeTokens} color="primary" />
            </div>
            <Text type="h200">Dashboard</Text>
          </Row>
          <Column>
            <Row>
              <Text type="b500">Inspection History</Text>
            </Row>
          </Column>
        </Column>
        <Column spacingInset="none 500">
          {completedInspections.length > 0 ? (
            completedInspections.map((inspection) => (
              <CompletedInspectionCard
                key={`${inspection.inspectionId}`}
                inspection={inspection}
              />
            ))
          ) : (
            <Text>You don't have any completed inspections.</Text>
          )}
        </Column>
      </Column>
    </Column>
  );
};

export default CompletedInspections;
